
/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

//import $ from 'jquery';

export default class gtServicesSlider{
    init (){
        if($('.js-gtServices-slider').length){

            var swiper = new Swiper(".js-gtServices-slider", {
                slidesPerView: "auto",
                freeMode: true,
                spaceBetween: 30,
                lazy: {
                    loadedClass: 'loaded',
                    checkInView: true,
                },
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                navigation: {
                    nextEl: '.js-gtServices-slider-next',
                    prevEl: '.js-gtServices-slider-prev'
                }
            });
        }
    }
}